const { restoredPages } = require('./restored-pages.cjs');

const pages = {
  '/': {
    title: 'Maître Diamma | Marabout africain en Guadeloupe',
    description: 'Maître Diamma, marabout en Guadeloupe : retour affectif, voyance et rituels spirituels. Contact par téléphone ou WhatsApp au +33 7 45 44 96 41.',
    heading: 'Maître Diamma — Marabout africain en Guadeloupe',
  },
  '/retour-affectif-guadeloupe': {
    title: 'Retour affectif en Guadeloupe | Maître Diamma',
    description: 'Consultez Maître Diamma pour un retour affectif en Guadeloupe. Informations sur les rituels et contact direct par téléphone ou WhatsApp au +33 7 45 44 96 41.',
    heading: 'Retour affectif en Guadeloupe — Maître Diamma',
    label: 'Retour affectif en Guadeloupe',
  },
  ...restoredPages,
};

// Shared by Node's build tools and the browser as an explicit CommonJS module.
const getSiteOrigin = (siteUrl) => {
  if (!siteUrl) throw new Error('REACT_APP_SITE_URL est requis pour les URL publiques du site.');
  const parsed = new URL(siteUrl);
  if (parsed.protocol !== 'https:' || parsed.username || parsed.password || parsed.port ||
      parsed.pathname !== '/' || parsed.search || parsed.hash) {
    throw new Error('REACT_APP_SITE_URL doit être une origine HTTPS sans chemin, port ou identifiants.');
  }
  return parsed.origin;
};

const getPageSeo = (pathname, siteUrl) => {
  const origin = getSiteOrigin(siteUrl);
  const path = pathname.replace(/\/+$/, '') || '/';
  const page = pages[path];
  const url = `${origin}${path}`;
  const provider = {
    '@type': 'Organization', '@id': `${origin}/#organization`,
    name: 'Maître Diamma', url: `${origin}/`, telephone: '+33745449641',
    areaServed: { '@type': 'AdministrativeArea', name: 'Guadeloupe' },
  };
  return {
    ...(page || { title: 'Page introuvable | Maître Diamma', description: 'Retrouvez les consultations de Maître Diamma en Guadeloupe.', heading: 'Page introuvable' }),
    url,
    robots: page ? 'index, follow, max-image-preview:large' : 'noindex, follow',
    schema: page ? {
      '@context': 'https://schema.org',
      '@graph': path === '/' ? [provider, {
        '@type': 'WebSite', '@id': `${origin}/#website`, url: `${origin}/`,
        name: 'Maître Diamma — Marabout en Guadeloupe', inLanguage: 'fr',
        publisher: { '@id': provider['@id'] },
      }] : [provider, page.kind === 'article' ? {
        '@type': 'Article', '@id': `${url}#article`, url,
        headline: page.heading, inLanguage: 'fr',
        publisher: { '@id': provider['@id'] },
        author: { '@id': provider['@id'] },
      } : {
        '@type': 'Service', '@id': `${url}#service`, url,
        name: page.heading, provider: { '@id': provider['@id'] },
        areaServed: { '@type': 'AdministrativeArea', name: page.city || 'Guadeloupe' },
      }, {
        '@type': 'BreadcrumbList', itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Accueil', item: `${origin}/` },
          { '@type': 'ListItem', position: 2, name: page.label || page.heading, item: url },
        ],
      }],
    } : null,
  };
};

module.exports = { pages, getSiteOrigin, getPageSeo };